export default __webpack_public_path__ + "static/softsettings-7964474f895b43095e63d5ac8a52278c.png";